import { get } from '../core';
export var BASE_FONT_SIZE = 13;
var PRESET_FONT_SIZES = {
  body: 13,
  caption: 10,
  footnote: 11,
  largeTitle: 28,
  subheadline: 12,
  title: 20
};
var HEADING_FONT_SIZES = [1, 2, 3, 4, 5, 6];
/**
 *
 * @param {import('react').CSSProperties['fontSize'] | 'body' | 'caption' | 'footnote' | 'largeTitle' | 'subheadline' | 'title'} size
 * @return {string}
 */

export function getFontSize(size) {
  if (size === void 0) {
    size = BASE_FONT_SIZE;
  }

  if (PRESET_FONT_SIZES[size]) {
    return getFontSize(PRESET_FONT_SIZES[size]);
  }

  if (typeof size !== 'number') return size;
  var ratio =
  /** @type {number} */
  size / BASE_FONT_SIZE;
  return "calc(" + ratio + " * " + get('fontSize') + ")";
}
export function getHeadingFontSize(size) {
  if (size === void 0) {
    size = 3;
  }

  if (!HEADING_FONT_SIZES.includes(size)) {
    return getFontSize(size);
  }

  var headingSize = "fontSizeH" + size;
  /* @ts-ignore */

  return get(headingSize);
}